module.exports = __webpack_public_path__ + "static/media/bg1.4df3f559.png";